import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesSection from './components/ServicesSection';
import WhyChooseUs from './components/WhyChooseUs';
import AboutSection from './components/AboutSection';
import TestimonialsSection from './components/TestimonialsSection';
import ServiceAreasSection from './components/ServiceAreasSection';
import ProcessSection from './components/ProcessSection';
import SpecialOfferSection from './components/SpecialOfferSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import GallerySection from './components/GallerySection';
import QuoteFormSection from './components/QuoteFormSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesSection />
        <WhyChooseUs />
        <AboutSection />
        <TestimonialsSection />
        <ServiceAreasSection />
        <ProcessSection />
        <SpecialOfferSection />
        <FAQSection />
        <CTASection />
        <GallerySection />
        <QuoteFormSection />
      </main>
      <Footer />
    </div>
  );
}